import(/* webpackMode: "eager" */ "/home/runner/work/brics-website/brics-website/app/[locale]/not-found.module.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/brics-website/brics-website/node_modules/next/dist/client/link.js");
